export enum Keys {
    BACKSPACE = 'Backspace',
    TAB = 'Tab',
    ENTER = 'Enter',
    CAPS_LOCK = 'CapsLock',
    ESC = 'Escape',
    SPACE = ' ',
    PAGE_UP = 'PageUp',
    PAGE_DOWN = 'PageDown',
    END = 'End',
    HOME = 'Home',
    LEFT = 'ArrowLeft',
    UP = 'ArrowUp',
    RIGHT = 'ArrowRight',
    DOWN = 'ArrowDown',
    INSERT = 'Insert',
    DELETE = 'Delete',
}

type KeyboardKeys = `${Keys}`;

/**
 * Проверяет совпадает ли название клавиши из `keys` с тем, что передано в `event`.
 *
 * @example
 * isKeyCode(event, [Keys.ESC, Keys.ENTER])
 *
 * @param event Клависатурное событие.
 * @param keys Список клавиш в виде строкового или числового представления.
 * @returns true/false
 */
export function isKeyCode(
    event: Pick<KeyboardEvent, 'key'>,
    keys: readonly KeyboardKeys[],
): boolean {
    return keys.some((value) => value === event.key);
}
